import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';
// import { GoogleLogin } from '@react-oauth/google';
// import axios from 'axios'; // Importar axios para a chamada do google-login

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth();
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await login(email, password);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao fazer login.');
    }
  };

  // Comentado para desabilitar registro via Google
  // const handleGoogleSuccess = async (credentialResponse) => {
  //   try {
  //     // Envia o ID token do Google para o backend para verificação e login/registro
  //     const response = await axios.post('http://localhost:8000/api/v1/auth/google-login', {
  //       id_token_from_google: credentialResponse.credential
  //     });
  //     // A resposta do backend deve ser um token JWT
  //     // O AuthContext.login espera email e password, mas o google-login retorna o token
  //     // Precisamos adaptar a função login do AuthContext ou criar uma nova para googleLogin
  //     // Por enquanto, apenas armazenaremos o token e navegaremos.
  //     localStorage.setItem('access_token', response.data.access_token);
  //     window.location.href = '/dashboard/overview'; // Força refresh para AuthContext reavaliar
  //     // Ou, alternativamente, modificar useAuth().login para aceitar um objeto de resposta de token
  //     // await login(null,null,response.data.access_token); // Exemplo hipotético de adaptação
  //   } catch (error) {
  //     console.error("Google login failed:", error.response?.data || error.message);
  //     setError(error.response?.data?.detail || 'Erro ao fazer login com Google.');
  //   }
  // };

  // const handleError = () => {
  //   console.log('Google Login Failed');
  //   setError('Falha no login com Google. Tente novamente.');
  // };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Entrar na sua conta
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Acesse o sistema Ediand
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit} role="form" aria-label="Formulário de login">
          <div className="bg-white py-8 px-6 shadow rounded-lg space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                Email
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                  </svg>
                </div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  className="appearance-none relative block w-full px-10 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                  placeholder="seu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  aria-describedby="email-error"
                />
              </div>
            </div>
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                Senha
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                </div>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="appearance-none relative block w-full px-10 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  aria-describedby="password-error"
                />
              </div>
            </div>
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md flex items-center" role="alert" aria-live="polite">
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
                <span id="login-error">{error}</span>
              </div>
            )}
            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-150 ease-in-out"
                aria-describedby="login-button"
              >
                Entrar
              </button>
            </div>
            {/* Comentado para desabilitar registro via Google */}
            {/* <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300" />
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-white text-gray-500">Ou</span>
              </div>
            </div>
            <div>
              <div className="flex justify-center">
                <GoogleLogin
                  onSuccess={handleGoogleSuccess}
                  onError={handleError}
                  theme="outline"
                  size="large"
                  text="signin_with"
                  shape="rectangular"
                />
              </div>
            </div> */}
          </div>
          <div className="text-center space-y-2">
            {/* Comentado para desabilitar registro */}
            {/* <p className="text-sm text-gray-600">
              Não tem uma conta?{' '}
              <Link to="/register" className="font-medium text-blue-600 hover:text-blue-500 transition duration-150 ease-in-out">
                Crie uma aqui
              </Link>
            </p> */}
            <p className="text-sm text-gray-600">
              Esqueceu sua senha?{' '}
              <Link to="/forgot-password" className="font-medium text-blue-600 hover:text-blue-500 transition duration-150 ease-in-out">
                Recupere aqui
              </Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;